import React from 'react';
import { Link } from 'react-scroll';
import { motion } from 'framer-motion';
import './Hero.css';

const Hero = () => {
  return (
    <motion.section id="home" className="hero" initial={{ opacity: 0, y: 50 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true, amount: 0.3 }} transition={{ duration: 0.8, ease: "easeOut" }}>
      <div className="container">
        <motion.div className="hero-content" initial={{ opacity: 0, x: -50 }} whileInView={{ opacity: 1, x: 0 }} viewport={{ once: true, amount: 0.3 }} transition={{ duration: 0.6, delay: 0.2 }}>
          <motion.h1 initial={{ opacity: 0, x: -30 }} whileInView={{ opacity: 1, x: 0 }} viewport={{ once: true }} transition={{ duration: 0.6, delay: 0.4 }}>AI-Driven Healthcare: Transforming Patient Care</motion.h1>
          <motion.p initial={{ opacity: 0, x: -30 }} whileInView={{ opacity: 1, x: 0 }} viewport={{ once: true }} transition={{ duration: 0.6, delay: 0.6 }}>Revolutionizing wound care management with intelligent diagnosis and monitoring</motion.p>
          <Link to="solution" className="btn-primary" smooth={true} offset={-80} duration={500}>
            Get Started
          </Link>
          <Link to="about" className="btn-secondary" smooth={true} offset={-80} duration={500}>
            Learn More
          </Link>
        </motion.div>
        <div className="hero-image">
          <div className="image-container">
            <div className="circle"></div>
            <img src="/Picture5.png" alt="AI Healthcare" style={{ maxWidth: '100%', height: 'auto' }} />
          </div>
        </div>
      </div>
    </motion.section>
  );
};

export default Hero;
